<template>
  <v-app>
    <cabecerados/>
    <v-main>
      <v-container>
        <v-alert
            :value="alerterror"
            color="error"
            dark
            dismissible
            border="top"
            transition="scale-transition"
        >
          {{error}}
        </v-alert>
        <v-row  v-if="existe" justify="center">
          <v-col v-if="conectado" cols="12" sm="12" lg="9" md="9">
            <v-card v-if="usado">
              <v-card-title>Código Usado</v-card-title>
              <v-card-subtitle>El Código que ingreso fue usado por otro usuario, por favor ingrese otro.</v-card-subtitle>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12" lg="12">
                    <v-text-field v-model="codigoUnico" label="Código"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12" lg="12">
                    <v-btn class="primary" @click="traeCodigo">
                      <v-icon>
                        fas fa-qrcode
                      </v-icon>
                      Comprobar de nuevo</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card v-else>
              <v-card-title>
                Validación Código
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <p>QR Asignado con Éxito.</p>
                    <p><v-btn @click="gosotorgaqr">Ver QR</v-btn></p>

                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p>Lista de QR's</p>
                    <p>También puedes ir a tu lista de QR's y bajarlo a tu wallet</p>
                    <p><v-btn :to="{name : 'misqrs'}">LISTA QR's</v-btn></p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-else cols="12" sm="12" lg="9" md="9">
            <v-card>
              <v-card-title>
                Validación Código / Login o Registro
              </v-card-title>
              <v-card-text v-if="this.tipo === 1">
                <div>
                     <v-row justify="center" align="center">
                             <v-col v-if="normal">
                               <v-row>
                                 <v-col>
                               <br/><p>Tu código para la fiesta <strong>{{codigo.listaDetalleFiestaMaster.nombreActo}}</strong> existe</p>
                               <p>Los siguientes pasos para obtener tu QR rápidamente son : </p>
                               <ul>
                                 <li >Si eres nuevo Registrate, si ya tienes una cuenta con nosotros ingresa con Email.</li><li v-if="browser">Puedes igualmente ingresar directamente con Google o Apple, sin necesidad de registrarte.</li>
                                 <li v-else>Ingresaste por un browser interno de Instagram o algún otra app, para ingresar con Google o Apple te recomendamos abrir Chrome o Safari</li>
                               </ul> </v-col>
                                 <v-col lg="12" md="12" cols="12">Al registrarse está aceptando nuestros <a href="https://tunay.app/terminos" target="_blank">Terminos y Condiciones</a> y <a href="https://tunay.app/politicas" target="_blank">Políticas de Privacidad</a></v-col>

                               </v-row>
                               <v-row v-if="browser" justify="center" align="center">
                                 <v-col cols="10" lg="3" md="3">
                                   <v-btn rounded width="100%" style="background: #4F86EC;" @click="signingoogle">
                                     <v-icon>fab fa-google</v-icon> &nbsp;Ingresa con Google
                                   </v-btn>
                                 </v-col>
                               </v-row>
                               <v-row v-if="browser" justify="center" align="center">
                                 <v-col cols="10" lg="3" md="3">
                                   <v-btn rounded width="100%" style="background: #E0E5FA; color: black;" @click="signinapple">
                                     <v-icon>fab fa-apple</v-icon> &nbsp;Ingresa con Apple
                                   </v-btn>
                                 </v-col>
                               </v-row>
                               <v-row justify="center" align="center">
                                 <v-col cols="10" lg="3" md="3">
                                   <v-btn rounded width="100%" style="background: #FFFFFF; color: black;" @click="signinemail">
                                     <v-icon>fas fa-envelope</v-icon> &nbsp;Ingresa con Email
                                   </v-btn>
                                 </v-col>
                               </v-row>
                               <v-row justify="center" align="center">
                                 <v-col cols="10" lg="3" md="3">
                                   ¿Eres nuevo?
                                 </v-col>
                               </v-row>
                               <v-row justify="center" align="center">
                                 <v-col cols="10" lg="3" md="3">
                                   <v-btn rounded width="100%" style="background: cornflowerblue; color: black;" @click="registeremail">
                                     <v-icon>fas fa-envelope</v-icon> &nbsp;Registrate con Email
                                   </v-btn>
                                 </v-col>
                               </v-row>
                             </v-col>
                              <v-col v-if="login" lg="6" md="6" cols="12" sm="6">
                                <v-row justify="center" align="center">
                                  <v-col lg="12" md="12" cols="12" sm="12">
                                  <h2>Conectarse</h2>
                                  </v-col>
                                <v-col lg="12" md="12" cols="12" sm="12">
                                  <v-text-field v-model="email"  type="email" label="Email"></v-text-field>
                                </v-col>
                                <v-col lg="12" md="12" cols="12" sm="12">
                                  <v-text-field v-model="password" type="password" label="Password"></v-text-field>
                                </v-col>
                                </v-row>
                                <v-row >
                                  <v-col md="6" lg="6" cols="6" sm="6">
                                    <v-btn rounded  @click="submit" class="primary">Ingresar</v-btn>
                                  </v-col>
                                  <v-col md="6" lg="6" cols="6" sm="6">
                                    <v-btn rounded style="background-color: red;"  @click="volver" >Volver</v-btn>
                                  </v-col>
                                </v-row>

                              </v-col>
                              <v-col v-if="registro" lg="6" md="6" cols="12" sm="6">
                                <v-row justify="center">
                                  <v-col lg="12" md="12" cols="12" sm="12">
                                    <h2>Registrarse</h2>
                                  </v-col>
                                  <v-col lg="6" md="6" cols="10" sm="6">
                                    <v-text-field v-model="form.nombre"   label="Nombre"></v-text-field>
                                  </v-col>
                                  <v-col lg="6" md="6" cols="10" sm="6">
                                    <v-text-field v-model="form.apellidoPaterno"   label="Apellido Paterno"></v-text-field>
                                  </v-col>
                                  <v-col lg="6" md="6" cols="10" sm="6">
                                    <v-text-field v-model="form.email"  type="email" label="Email"></v-text-field>
                                  </v-col>
                                  <v-col lg="6" md="6" cols="10" sm="6">
                                    <v-text-field v-model="form.telefono" type="number"  label="Telefono"></v-text-field>
                                  </v-col>
                                  <v-col lg="6" md="6" cols="10" sm="6">
                                    <v-text-field v-model="password2" type="password" label="Password"></v-text-field>
                                  </v-col>

                                  <v-col md="6" lg="6" cols="5" sm="6" >
                                    <v-btn rounded @click="register" class="primary">Registrarse</v-btn>
                                  </v-col>
                                  <v-col md="6" lg="6" cols="5" sm="6" >
                                    <v-btn rounded @click="volver" class="error">Volver</v-btn>
                                  </v-col>
                                </v-row>

                              </v-col>
                            </v-row>

                </div>
              </v-card-text>
              <v-card-text v-if="this.tipo === 2">


                <v-row>
                    <v-col v-if="normal" lg="6" md="6" cols="12" sm="6">
                      <h1>Hola {{codigo.ticketMasterEntity.persona.personaNombre}}</h1>
                      <br/><p>Tu código para el evento <strong>{{codigo.ticketMasterEntity.eventoEntrada.eventoEntradaZonaEvento.zonaEventoEvento.evento}}</strong> existe</p>
                      <p>Los siguientes pasos para obtener tu QR rápidamente son : </p>
                      <ul>
                        <li>Registrarte o Conectarte si ya tienes una cuenta con nosotros, tenga en cuenta que si se logea o registra con otro nombre se actualizara el nombre de la entrada, por lo que no comparta nunca su código.</li>
                      </ul>
                      <v-row v-if="browser" justify="center" align="center">
                        <v-col cols="10" lg="3" md="3">
                          <v-btn rounded width="100%" style="background: #4F86EC;" @click="signingoogle">
                            <v-icon>fab fa-google</v-icon> &nbsp;Ingresa con Google
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row v-if="browser" justify="center" align="center">
                        <v-col cols="10" lg="3" md="3">
                          <v-btn rounded width="100%" style="background: #E0E5FA; color: black;" @click="signinapple">
                            <v-icon>fab fa-apple</v-icon> &nbsp;Ingresa con Apple
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col cols="10" lg="3" md="3">
                          <v-btn rounded width="100%" style="background: #FFFFFF; color: black;" @click="signinemail">
                            <v-icon>fas fa-envelope</v-icon> &nbsp;Ingresa con Email
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col cols="10" lg="3" md="3">
                          ¿Eres nuevo?
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col cols="10" lg="3" md="3">
                          <v-btn rounded width="100%" style="background: cornflowerblue; color: black;" @click="registeremail">
                            <v-icon>fas fa-envelope</v-icon> &nbsp;Registrate con Email
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col v-if="login" lg="6" md="6" cols="12" sm="6">
                      <v-row>
                        <v-col lg="12" md="12" cols="12" sm="12">
                          <h2>Conectarse</h2>
                        </v-col>
                        <v-col lg="12" md="12" cols="12" sm="12">
                          <v-text-field v-model="email"  type="email" label="Email"></v-text-field>
                        </v-col>
                        <v-col lg="12" md="12" cols="12" sm="12">
                          <v-text-field v-model="password" type="password" label="Password"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row >
                        <v-col md="6" lg="6" cols="6" sm="6">
                          <v-btn rounded @click="submit" class="primary">Ingresar</v-btn>
                        </v-col>
                        <v-col md="6" lg="6" cols="6" sm="6">
                          <v-btn rounded style="background-color: red;"  @click="volver" >Volver</v-btn>
                        </v-col>
                      </v-row>

                    </v-col>
                    <v-col v-if="registro" lg="6" md="6" cols="12" sm="6">
                      <v-row>
                        <v-col lg="12" md="12" cols="12" sm="12">
                          <h2>Registrarse</h2>
                        </v-col>
                        <v-col lg="6" md="6" cols="6" sm="6">
                          <v-text-field v-model="form.nombre"   label="Nombre"></v-text-field>
                        </v-col>
                        <v-col lg="6" md="6" cols="6" sm="6">
                          <v-text-field v-model="form.apellidoPaterno"   label="Apellido Paterno"></v-text-field>
                        </v-col>
                        <v-col lg="6" md="6" cols="6" sm="6">
                          <v-text-field v-model="form.email"  type="email" label="Email"></v-text-field>
                        </v-col>
                        <v-col lg="6" md="6" cols="6" sm="6">
                          <v-text-field v-model="password2" type="password" label="Password"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row >
                        <v-col md="6" lg="6" cols="6" sm="6" >
                          <v-btn rounded @click="register" class="primary">Registrarse</v-btn>
                        </v-col>
                        <v-col md="6" lg="6" cols="6" sm="6">
                          <v-btn rounded style="background-color: red;"  @click="volver" >Volver</v-btn>
                        </v-col>
                      </v-row>

                    </v-col>
                  </v-row>

              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else justify="center">
          <v-col  cols="12" sm="12" lg="9" md="9">
                <v-card>
                  <v-card-title>Código Incorrecto</v-card-title>
                  <v-card-subtitle>El Código que ingreso no existe en nuestra base de datos, puede buscar de nuevo.</v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="12" lg="12">
                          <v-text-field v-model="codigoUnico" label="Código"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="12" lg="12">
                          <v-btn class="primary" @click="traeCodigo">
                            <v-icon>
                              fas fa-qrcode
                            </v-icon>
                            Comprobar de nuevo</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <piepagina/>
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-app>
</template>
<script>


import cabecerados from '../general/cabecerados';
import piepagina from '../general/piepagina';
import {mapGetters} from "vuex";
import axios from "axios";
import store from "@/store";
import tipoentrjson from "@/assets/json/tipoentradas.json";
import tipopagjson from "@/assets/json/tipopagos.json";
import tipoevenjson from "@/assets/json/tipoeventos.json";
import tipomembrjson from "@/assets/json/tipomembresias.json";
import sexosjson from "@/assets/json/sexos.json";
import estadocarjson from "@/assets/json/estadocarnet.json";
import diasjson from "@/assets/json/dias.json";
import firebase from 'firebase/compat/app';
import moment from "moment-timezone";

export default {
  name: 'validaqr',
  components: {
    cabecerados,
    piepagina,

  },
  data () {
    return {
      codigo: {},
      email: '',
      token:'',
      mnegocios : null,
      tnegocios: false,
      teventos: false,
      normal:true,
      login:false,
      registro:false,
      tpromotor: false,
      form: {
        nombre: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        dni : "",
        foto: "",
        email: "",
        paisNac:null,
        tipoDocumento: null,
        telefono:"",
        direccion:"",
        fechaNacimiento:null,
        sexo:null,
        fotoDni:"",
        postalCode:"",
        distrito:null,
        createdAt:"",
        uidFirebase: "",
        isprofile: true,
        isfoto : false,
        isverified: false
      },
      existe: false,
      password:'',
      alerterror:false,
      error:'',
      password2:'',
      idlistadetalle:0,
      tipo:0,
      codigoUnico:'',
      overlay:false,
      existepersona: false,
      usado: false,
      rese:'',
    browser:false,
    }
  },
  mounted() {
    this.codigoUnico = this.$route.params.codigo
    this.fnBrowserDetect();
    if(this.usuario.id>0){

      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
      store.dispatch("conectarse")
    }else{
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false

              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              store.dispatch("conectarse")
            }else{
              this.overlay = false
            }
          })
    }
    this.traeCodigo()
  },
  watch:{
    '$store.state.usuario': function (){

      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
      store.dispatch("conectarse")
    },
  },
  methods:{

    fnBrowserDetect(){

      let userAgent = navigator.userAgent;

      if(userAgent.match(/chrome|chromium|crios/i)){
        this.rese = "chrome";
        this.browser = true;
      }else if(userAgent.match(/firefox|fxios/i)){
        this.rese = "firefox";
        this.browser = true;
      }  else if(userAgent.match(/safari/i)){
        this.rese = "safari";
        this.browser = true;
      }else if(userAgent.match(/opr\//i)){
        this.rese = "opera";
        this.browser = true;
      } else if(userAgent.match(/edg/i)){
        this.rese = "edge";
        this.browser = true;
      }else{
        this.rese="No browser detection";
        this.browser = false;
      }

    },
    gosotorgaqr(){
      console.log("mandalo a otorga")
      this.$router.push({name:"otorgarqr", params:{"codigoUnico": this.codigoUnico}})
    },
    submit() {
      this.overlay = true;
      firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(data => {
            this.form.email = this.email
            this.compruebaemail(data.user)
          })
          .catch(err => {
            if(err.code === "auth/user-not-found"){
              firebase
                  .auth()
                  .createUserWithEmailAndPassword(this.email,this.password)
                  .then((userCredential) =>{
                    const user = userCredential.user

                    this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                    this.form.email = this.email
                    this.compruebaemail(user)
                  })
              this.overlay = false;

            }else{
              this.error = "Puede haber un error con el email y/o password";
              this.overlay = false;
              this.alerterror = true;
            }
          });
    },
    formatDateee(value) {
      var fec = moment(value).locale('es-pe');

      return fec.tz(this.cliente.timeZone.timeZone).format("YYYY-MM-DD hh:mm:ss")
    },
    registrar(user){
      this.form.uidFirebase = user.uid
      var bodyFormData = new FormData();
      this.form.createdAt = null
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

      bodyFormData.append('data',JSON.stringify(this.form));
      axios.post("personas/registrar",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            store.dispatch("fetchUsuario", response.data.persona);
            store.dispatch("fetchTipoEntradas", tipoentrjson);
            store.dispatch("fetchTipoPagos", tipopagjson);
            store.dispatch("fetchTipoEventos", tipoevenjson);
            store.dispatch("fetchTipoMembresias", tipomembrjson);
            store.dispatch("fetchSexos", sexosjson);
            store.dispatch("fetchEstadoCarnets", estadocarjson);
            store.dispatch("fetchDias", diasjson);
            store.dispatch("conectarse")
            this.estaConectado();
            this.overlay = false;
          })

    },
    compruebaemail(user){
      var bodyFormData2 = new FormData();
      if(this.form.email !== ''){
        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

        bodyFormData2.append("email",this.form.email)
      axios
          .post('personas/email',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            var person = response.data
            if (person.id == null){
              this.registrar(user)
            }else{
              if(person.uidFirebase == null) {
                this.editar(user,person.id)
              }else{
                if(person.uidFirebase !== user.uid ){
                  this.editar(user,person.id)
                }else{
                  this.logeo(user)
                }
              }
            }
          })
          .catch((error)  => {
            console.log(error);
          });}else{
        this.error = "Hubo un error con su Conexion";
        this.alerterrorregister = true;

      }
    },
    editar(user,id){
      this.form.uidFirebase = user.uid
      var bodyFormData = new FormData();
      this.form.createdAt = this.formatDateee(new Date())
      this.form.fechaNacimiento = null
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

      bodyFormData.append('uidfirebase',this.form.uidFirebase);
      bodyFormData.append("personaId",id)
      this.overlay = true
      axios.post("personas/editafb",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            console.log(response.data);
            this.logeo(user)
            this.overlay = false
          })
          .catch(error => {
            console.log(error)
            this.overlay = false
          });
    },
    register(){

        this.overlay = true;
        firebase
            .auth()
            .createUserWithEmailAndPassword(this.form.email,this.password2)
            .then((userCredential) =>{
              const user = userCredential.user

              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.compruebaemail(user)
            })
            .catch(error => {
              if(error.code ==="auth/email-already-exists"){
                this.error = "Este email existe en Tunay se le esta enviando un mail automatico para cambiar de contraseña";
                firebase
                    .auth()
                    .sendPasswordResetEmail(this.form.email);
              }else{
                if(error.code === "auth/email-already-in-use"){
                  this.error = "Su Correo existe en nuestra base de datos con Google Mail o Apple Login por favor intente con Registrarse con Google o Registrarse con Apple, tambien puede intentarlo con Login con Google o Login con Apple";
                  firebase
                      .auth()
                      .sendPasswordResetEmail(this.form.email);
                  this.alerterror = true;
                }else{
                  this.error = "Hubo un error con su Conexion";

                }

              }
              this.overlay = false;
              this.alerterror = true;
              firebase
                  .auth()
                  .sendPasswordResetEmail(this.form.email);
              console.error(error);
            });
    },
    signinemail(){
      this.normal=false;
      this.login = true;
    },
    registeremail(){
      this.normal = false;
      this.registro = true;
    },
    volver(){
      this.normal = true;
      this.login = false;
      this.registro = false;
    },
    logeo(user){
      var bodyFormData = new FormData();
      bodyFormData.append('uuid', user.uid);
      this.overlay = true
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

      axios.post("personas/loginbyuid",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            store.dispatch("fetchUsuario", response.data.persona);
            store.dispatch("fetchClientes", response.data.clientes);
            store.dispatch("fetchCliente", response.data.clientes[0]);
            store.dispatch("fetchTipoEntradas", tipoentrjson);
            store.dispatch("fetchTipoPagos", tipopagjson);
            store.dispatch("fetchTipoEventos", tipoevenjson);
            store.dispatch("fetchTipoMembresias", tipomembrjson);
            store.dispatch("fetchSexos", sexosjson);
            store.dispatch("fetchEstadoCarnets", estadocarjson);
            store.dispatch("fetchDias", diasjson);
            store.dispatch("conectarse");
            this.overlay = false;
            this.estaConectado();
          })
          .catch(error => {
            this.registrar(user);
            this.overlay = false;

            console.log(error);
          });
    },
    codigoCanjeado(){
      this.existe = true
      this.usado = true
      if(this.usuario.id === this.codigo.personaDTO.personaId){
        this.gosotorgaqr()
      }
    },
    traeCodigo(){
      this.overlay = true
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

      axios
      .get('general/codigo/'+this.codigoUnico.trim(),{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then((response)  => {
            this.codigo = response.data;
            this.overlay = false;
            console.log(this.codigo)
            if(this.codigo.existe){
                if(this.codigo.personaDTO == null ){
                  this.codigoExiste();
                }else{
                  this.codigoCanjeado();
                }

            }else{
              this.codigoNoExiste();
            }
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false;
          });
    },
    codigoNoExiste(){
      this.existe = false

    },
    codigoExiste(){
      this.existe = true
      this.tipo = this.codigo.tipoLista
      if(this.conectado){
        this.estaConectado();
      }else{
        this.noConectado();
      }
    },
    estaConectado(){
      if(this.tipo === 1){
        console.log("pasa x fiesta");
        this.codigoFiesta();
      }

    },
    codigoFiesta(){
      if(this.codigo.listaDetalleFiestaMaster.idPersona == null || this.codigo.listaDetalleFiestaMaster.idPersona === 0){
        console.log("no tiene asignado")
        this.noHayPersonaAsignadaFiesta()
      }else{
        console.log("tiene asignado")
        this.gosotorgaqr();
      }
    },
    noHayPersonaAsignadaFiesta(){
      console.log("pasa x asignacion");
      this.overlay = true
      var bodyFormData = new FormData();
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

      bodyFormData.append('codigo', this.codigoUnico.trim());
      bodyFormData.append('personaId', this.usuario.id);
      axios
          .post('general/codigo/fiesta',bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then((response)  => {
            this.codigo = response.data;
            this.overlay = false;
            this.gosotorgaqr();
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false;
          });
    },
    noConectado(){

    },

    signingoogle(){
      var provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;

            // The signed-in user info.
            var user = result.user;
            this.form.nombre = user.displayName
            this.form.email =  user.email
            this.form.foto =  user.photoURL

            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;
            if(this.form.email ===''){
              this.error = "Tiene que compartir sus datos sino no es posible el registro.";
              this.overlay = false;
              this.alertloginerror = true;
            }else{
              this.compruebaemail(user)
            }
            // ...
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            // ...
          });
    },
    signinapple(){
      var provider = new firebase.auth.OAuthProvider('apple.com')
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;

            // The signed-in user info.
            var user = result.user;
            this.form.nombre = user.displayName
            this.form.email =  user.email
            this.form.foto =  user.photoURL

            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;
            if(this.form.email ===''){
              this.error = "Tiene que compartir sus datos sino no es posible el registro.";
              this.overlay = false;
              this.alertloginerror = true;
            }else{
              this.compruebaemail(user)
            }
            // ...
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // ...
          });
    },
    creategoogle(){
      var provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;

            // The signed-in user info.
            var user = result.user;
            this.form.nombre = user.displayName
            this.form.email =  user.email
            this.form.foto =  user.photoURL
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;

            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
            if(this.form.email ===''){
              this.error = "Tiene que compartir sus datos sino no es posible el registro.";
              this.overlay = false;
              this.alertloginerror = true;
            }else{
              this.compruebaemail(user)
            }
            // ...
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            // ...
          });
    },
    createapple(){
      var provider = new firebase.auth.OAuthProvider('apple.com')
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;

            // The signed-in user info.
            var user = result.user;
            this.form.nombre = user.displayName
            this.form.email =  user.email
            this.form.foto =  user.photoURL
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;

            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
            if(this.form.email ===''){
              this.error = "Tiene que compartir sus datos sino no es posible el registro.";
              this.overlay = false;
              this.alertloginerror = true;
            }else{
              this.compruebaemail(user)
            }

            // ...
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // ...
          });
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario",
      conectado: "conectado"
    })
  }
}
</script>
